import styled from "styled-components";
import { GameClubTabWrapperProps } from "../Club/GameClubTab";
import { ClubTab } from "../Hook/useGameClub";

export const GameClubWrapper = styled.div<{ isApp: number | null }>`
  position: relative;
  margin-bottom: 137px;
  margin-top: ${(p) => (p.isApp ? `${p.isApp + 47}px` : "47px")};
  text-align: center;
  overflow-x: hidden;
`;

export const GameClubTabWrapper = styled.div<GameClubTabWrapperProps>`
  position: fixed;
  margin-top: 20px;
  width: 100%;
  height: 27px;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid transparent;
  border-image: linear-gradient(
    0.6turn,
    rgb(56, 54, 35),
    rgb(186, 100, 58),
    rgb(122, 221, 235)
  );

  border-image-slice: 1;
  > .tab {
    flex: 1;
    position: relative;
    z-index: 1;
    cursor: pointer;
    transition: color 0.3s ease;

    > .title {
      color: white;

      font-size: 16px;
      font-weight: 700;
      text-align: center;
      transition: color 0.3s ease;
    }
  }

  // 이동하는 배경
  > .background {
    position: absolute;
    top: 0;
    left: ${({ activeTab }) => (activeTab === ClubTab.ALL ? "0%" : "50%")};
    width: 50%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(255, 205, 87, 0) 0%,
      #f2bf49 127.22%,
      #e0ad35 297.87%,
      #b68411 553.12%
    );
    z-index: 0;
    transition: left 0.5s ease;
  }
`;

export const GameClubHeaderWrapper = styled.div`
  position: relative;
  margin-top: 20px;
  width: 100%;
  height: 27px;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  padding: 0 21px;
  justify-content: space-between;
  display: flex;

  > .title-wrapper {
    display: flex;
    align-items: center;
    gap: 13px;
    width: 100%;
    justify-content: space-between;

    > .left {
      display: flex;
      align-items: center;
      gap: 6px;

      > .title {
        color: #fff;
        font-weight: 600;
        font-size: 16px;
      }

      > img {
        width: 14px;
        height: 14px;
      }
    }
  }
`;
